export * from "./types.js";
export * from "./slots.js";
import mapsJson from "../generated/maps.json" with { type: "json" };
import portraitJson from "../generated/avatars-portrait.json" with { type: "json" };
import editorJson from "../generated/avatars-editor.json" with { type: "json" };
import npcsJson from "../generated/npcs.json" with { type: "json" };
import soundJson from "../generated/sound.json" with { type: "json" };
import titleJson from "../generated/title.json" with { type: "json" };
import cautionJson from "../generated/caution.json" with { type: "json" };
import cardpacksJson from "../generated/cardpacks.json" with { type: "json" };
export const maps = mapsJson;
/** Enlarged "main" waist-up bust set (DATA/avatar/wu), gender-keyed; the
 *  customization/menu counterpart to the chibi paper-doll. */
export const avatarsPortrait = portraitJson;
/** 16-slot character-editor part set (TestData/waistup). */
export const avatarsEditor = editorJson;
export const npcs = npcsJson;
export const sound = soundJson;
export const title = titleJson;
export const caution = cautionJson;
export const cardpacks = cardpacksJson;
export const ALL_MAPS = maps.maps;
export const findMap = (id) => ALL_MAPS.find((m) => m.id === id);
export const findVariant = (set, slotId, variantId) => set.variants.find((v) => v.slotId === slotId && v.variantId === variantId);
//# sourceMappingURL=index.js.map